export class QuickTableGroupRowCalculator {
    getColumnAggregate(columnIndex, rows, groupByColumnIndex, showTotals) {
        if (!showTotals) {
            return '';
        }
        const visibleRows = rows.filter((row) => row.visible);
        const value = this.calculateValue(columnIndex, visibleRows, groupByColumnIndex);
        const formattedValue = this.formatValue(columnIndex, value, visibleRows);
        return formattedValue;
    }
    calculateValue(columnIndex, rows, groupByColumnIndex) {
        let sum = 0;
        for (const row of rows) {
            const cell = row.cells[columnIndex];
            sum += isNullOrUndefined(row.item)
                ? cell.value
                : row.item.getValueForTotalCalculation(columnIndex, row.table.totalCurrency);
        }
        return sum;
    }
    formatValue(columnIndex, value, rows) {
        if (isNaN(value)) {
            return '';
        }
        const row0 = rows[0];
        if (isNullOrUndefined(row0)) {
            return '';
        }
        return row0.item.getFormatTotalValue(columnIndex, value, row0.table.totalCurrency);
    }
}
